import React from 'react';
import DefaultView from 'components/ui/DefaultView';
import { Row, Col } from 'components/ui';
import DeliveryRate from './DeliveryRate';
import { Button, Icon, Spin } from 'antd';
import { useGetAllHomePageLinkGroups } from '../../query/misc';
import EditableScene from './EditableScene';
import HomeLink from './HomeLink';
import { useHomeCustomizationStore } from './EditableScene/store';
import { useUpdateHomePageLinkGroup } from '../../mutation/misc';
import { useDeepCompareEffect } from 'react-use';

const Home = () => {
  const { data } = useGetAllHomePageLinkGroups();
  const {
    setHomeState,
    homeState,
    editMode,
    toggleEditMode,
  } = useHomeCustomizationStore();
  useDeepCompareEffect(() => {
    setHomeState(data);
  }, [data]);
  const { mutateAsync, isLoading } = useUpdateHomePageLinkGroup();
  return (
    <DefaultView>
      <Row>
        <Spin spinning={isLoading}>
          <Col sm={12} xs={24}>
            <div>
              <div
                className="flex items-center"
                style={{ justifyContent: 'space-between' }}
              >
                <h1 cy-data="home-title">Email Communication System</h1>
                {editMode && (
                  <div className="flex items-center space-x-2">
                    <Icon
                      style={{ fontSize: 22 }}
                      theme="twoTone"
                      twoToneColor="#52c41a"
                      type="check-circle"
                      onClick={() => {
                        mutateAsync(homeState)
                          .then(() => toggleEditMode())
                          .catch(() => {});
                      }}
                    />
                    <Icon
                      style={{ fontSize: 22 }}
                      theme="twoTone"
                      twoToneColor="#ff3333"
                      type="close-circle"
                      onClick={() => {
                        // set back to prev state
                        setHomeState(data);
                        toggleEditMode();
                      }}
                    />
                  </div>
                )}
                {!editMode && (
                  <Button icon="edit" onClick={() => toggleEditMode()} />
                )}
              </div>
              <br />
              {editMode ? <EditableScene /> : <HomeLink data={data} />}
            </div>
          </Col>
          <Col sm={12} xs={24}>
            <DeliveryRate />
          </Col>
        </Spin>
      </Row>
    </DefaultView>
  );
};

export default Home;
